const MOBILE_BREAKPOINT = 640;
const initializedSections = new WeakSet();

const initMattersButtons = (scope = document) => {
  const sections = scope.matches?.('.matters-sec') ? [scope] : scope.querySelectorAll('.matters-sec');

  sections.forEach((section) => {
    if (initializedSections.has(section)) {
      return;
    }

    const container = section.querySelector('.matters-sec__container');
    const contents = container?.querySelectorAll(':scope > .matters-sec__content');
    const buttons = section.querySelector('.matters-sec__buttons');

    if (!contents || contents.length < 2 || !buttons) {
      return;
    }

    const [firstContent, secondContent] = contents;
    let frameId = null;

    const updateButtonsPosition = () => {
      const target = window.innerWidth <= MOBILE_BREAKPOINT ? secondContent : firstContent;

      if (buttons.parentElement !== target) {
        target.append(buttons);
      }
    };

    const handleResize = () => {
      if (frameId !== null) {
        return;
      }

      frameId = window.requestAnimationFrame(() => {
        frameId = null;
        updateButtonsPosition();
      });
    };

    updateButtonsPosition();
    window.addEventListener('resize', handleResize, { passive: true });
    initializedSections.add(section);
  });
};

initMattersButtons();
window.initMattersButtons = initMattersButtons;
